import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "font-semibold text-gray-700 truncate" }
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = { class: "flex justify-end" }

import { computed, reactive } from 'vue'
import { mapRelationship, mapRelationships } from '@/store/mappers'
import api from '@/store/api'
import { XCircleIcon } from '@heroicons/vue/24/outline'
import { ingredientMeasurementOptions } from '@/config/ingredientMeasurements'


export default {
  __name: 'ProductIngredients',
  props: ['id'],
  setup(__props) {

const props = __props

const product = computed(() => mapRelationship({ type: 'product', id: props.id }))
const ingredients = computed(() =>
  mapRelationships(product.value?.relationships.ingredients.data).sort((a, b) => a.id - b.id)
)

const modal = reactive({ open: false })

const addIngredient = () => {
  modal.open = true
  modal.id = null
  modal.name = ''
  modal.contains = ''
  modal.measurement = 'oz'
  modal.amount = ''
}

const editIngredient = ingredient => {
  modal.open = true
  modal.id = ingredient.id
  modal.name = ingredient.attributes.name
  modal.contains = ingredient.attributes.contains
  modal.measurement = ingredient.attributes.measurement
  modal.amount = ingredient.attributes.amount
}

const saveModal = () => {
  if (!modal.name) return
  modal.open = false
  api.call('PUT', `products/${props.id}?included=ingredients`, {
    product: {
      ingredients_attributes: [
        {
          id: modal.id,
          name: modal.name,
          contains: modal.contains,
          measurement: modal.measurement,
          amount: modal.amount
        }
      ]
    }
  })
}

const deleteIngredient = ingredient => {
  api.call('PUT', `products/${props.id}?included=ingredients`, {
    product: {
      ingredients_attributes: [{ id: ingredient.id, _destroy: true }]
    }
  })
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_InputField = _resolveComponent("InputField")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_TheModal = _resolveComponent("TheModal")

  return (product.value?.attributes.type === 'FoodProduct')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FormSection, { name: "Ingredients" }, {
          default: _withCtx(() => [
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                (ingredients.value.length)
                  ? (_openBlock(), _createBlock(_component_NeueTablist, { key: 0 }, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_TablistGrid, {
                              columns: ['Ingredient', 'Amount', 'Contains', ''],
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[6] || (_cache[6] = _createElementVNode("div", null, "Ingredient", -1)),
                                _cache[7] || (_cache[7] = _createElementVNode("div", null, "Amount", -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("div", null, "Contains", -1)),
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_NeueButton, {
                                    type: "secondary",
                                    onClick: addIngredient
                                  }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                      _createTextVNode("+ Ingredient", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ingredients.value, (ingredient) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            class: "cursor-pointer",
                            onClick: $event => (editIngredient(ingredient))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TablistGrid, {
                                columns: ['Ingredient', 'Amount', 'Contains', ''],
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, _toDisplayString(ingredient.attributes.name), 1),
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(ingredient.attributes.amount) + " " + _toDisplayString(ingredient.attributes.measurement), 1),
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(ingredient.attributes.contains), 1),
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(XCircleIcon), {
                                      class: "h-5 w-5 cursor-pointer text-gray-700",
                                      onClick: _withModifiers($event => (deleteIngredient(ingredient)), ["stop"])
                                    }, null, 8, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 256))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!ingredients.value.length)
                  ? (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 1,
                      plural: "ingredients"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_NeueButton, {
                          type: "secondary",
                          onClick: addIngredient
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("+ Ingredient", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_TheModal, {
          "is-open": modal.open,
          "modal-title": modal.new ? 'Add ingredient' : 'Edit ingredient',
          onCloseModal: _cache[4] || (_cache[4] = $event => (modal.open = false))
        }, {
          main: _withCtx(() => [
            _createVNode(_component_FormSection, null, {
              default: _withCtx(() => [
                _createVNode(_component_FormElement, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: modal.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((modal.name) = $event)),
                      name: "Name",
                      onKeyup: _withKeys(saveModal, ["enter"]),
                      placeholder: "Ingredient name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FormElement, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputArea, {
                      modelValue: modal.contains,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.contains) = $event)),
                      name: "Contains",
                      onKeyup: _withKeys(saveModal, ["enter"]),
                      placeholder: "Paprika, salt, etc. (optional)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FormElement, { size: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputField, {
                      modelValue: modal.amount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.amount) = $event)),
                      name: "Amount",
                      inputmode: "numeric",
                      onKeyup: _withKeys(saveModal, ["enter"]),
                      placeholder: "0.5"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FormElement, { size: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectInput, {
                      modelValue: modal.measurement,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.measurement) = $event)),
                      name: "Measurement",
                      options: _unref(ingredientMeasurementOptions)
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_NeueButton, {
              type: "secondary",
              onClick: _ctx.closeModal
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NeueButton, {
              type: modal.name ? 'primary' : 'inactive',
              onClick: saveModal
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Save", -1)
              ]))]),
              _: 1
            }, 8, ["type"])
          ]),
          _: 1
        }, 8, ["is-open", "modal-title"])
      ]))
    : _createCommentVNode("", true)
}
}

}